import { render, staticRenderFns } from "./DoorLockDamage.vue?vue&type=template&id=4172be83&scoped=true"
import script from "./DoorLockDamage.vue?vue&type=script&lang=ts"
export * from "./DoorLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172be83",
  null
  
)

export default component.exports